module.exports = __webpack_public_path__ + "static/media/blue-template-small.1243049b.png";